<template>
	<span class="translation-globe">
		<Tippy v-if="!hideTip" :content="tip" arrow theme="bluewhite">
			<EarthIcon :active="translated" @click.stop.prevent="$emit('click')" />
		</Tippy>
		<EarthIcon
			v-if="hideTip"
			:active="translated"
			@click.stop.prevent="$emit('click')"
		/>
	</span>
</template>

<script>
import { Tippy } from '@/components/common'
import { EarthIcon } from '@/icons'
import { getMyLanguage } from '@/store/translations'
import { getLanguagesData } from '@/helpers/firebase'

export default {
	name: 'TranslationGlobe',
	components: { EarthIcon, Tippy },
	props: {
		hideTip: { type: Boolean, default: null },
		lang: String,
		translated: { type: Boolean, default: null },
	},
	computed: {
		tip() {
			const languages = getLanguagesData()
			const myLang = getMyLanguage()
			const Language = languages.langs[this.lang].localizednames[myLang]

			if (this.translated) {
				return this.$t('chat_translation_translatedfrom_click', {
					Language,
				})
			}
			return this.$t('chat_translation_translatefrom_click', {
				Language,
			})
		},
	},
	emits: ['click'],
}
</script>

<style lang="scss" scoped>
.translation-globe {
	cursor: pointer;
	height: 1em;
	width: 1em;
}
</style>
